import { useAuthStore } from '../stores'

export async function initPayment(product: string, metadata?: Record<string, any>) {
  const { user } = useAuthStore.getState()
  if (!user) throw new Error('Not authenticated')

  const { backendClient } = await import('./backend')
  const { data: { session } } = await backendClient.auth.getSession()
  const accessToken = session?.access_token

  // Force relative path so Vercel Serverless Functions are hit correctly
  // (Prevents misconfigured VITE_API_BASE_URL in production from redirecting to index.html)
  const url = '/api/paystack/init-payment'

  const res = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify({ product, metadata }),
  })

  const contentType = res.headers.get('content-type') || ''
  const isJson = contentType.includes('application/json')

  if (!isJson) {
    const text = await res.text().catch(() => '')
    const snippet = text.slice(0, 100).replace(/\n/g, ' ')
    throw new Error(`Server returned non-JSON (Status ${res.status}). Response: ${snippet}`)
  }

  if (!res.ok) {
    const err = await res.json().catch(() => ({}))
    throw new Error(err.error || `Failed to initialize payment (Status: ${res.status})`)
  }

  return res.json()
}
